module.exports = __webpack_public_path__ + "static/media/makesThick.18233fb2.mp3";